console.log("collections.js");

//Swipe Images
let allProducts = document.querySelectorAll("#collection-con .product");

let setProduct = function (singleProduct) {
  let addSwiper = singleProduct.querySelector(".gallery-swiper");

  var swiper = new Swiper(addSwiper, {
    preloadImages: false,
    lazy: true,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });


  singleProduct.dataset.status = "dynamic";
};

window.addEventListener("load", function () {
  allProducts.forEach(function (item, i) {
    setProduct(item);
  });

  let nextBtn = document.querySelector("#paginate-next");

  if (nextBtn) {
    var elem = document.querySelector("#collection-con");
    var infScroll = new InfiniteScroll(elem, {
      path: "#paginate-next",
      append: ".product",
      history: false,
    });

    infScroll.on("append", function () {
      let allProducts = document.querySelectorAll("#collection-con .product");

      allProducts.forEach(function (item, i) {
        setProduct(item);
      });
    });
  }
});



//Filters
let filterWrap = document.querySelector("#co-filters");

if (filterWrap) {
  let filterToggle = filterWrap.querySelector(".filters-btn");

  filterToggle.addEventListener("click", function (event) {
    event.preventDefault();
    filterWrap.classList.toggle("open");
  });

  let filterBar = document.querySelector("#co-filters");

  let filterBtns = document.querySelectorAll(".filter-btn");
  let filterParent = document.querySelectorAll(".single-cat");
  let realFilters = document.querySelector(".filter-options");
  let filterCons = document.querySelectorAll(".list-of-options");
  let filterConsExtendo = document.querySelectorAll(".list-of-options-extended");
  let filterOriginals = document.querySelectorAll(".filter-group-display");

  //Open X list of option
  filterBtns.forEach(function (item, i) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      item.classList.toggle("active");
      filterParent[i].classList.toggle("show");
    });
  });

  //Set the options in my fake containers - Complete
  filterOriginals.forEach(function (item, i) {
    let theType = item.dataset.filterName;
    if (theType == "size") {
      let myClone = item.cloneNode(true);
      //console.log(item);
      let rtw = [];
      let shoes = [];
      let theOptions = myClone.querySelectorAll("li");
      theOptions.forEach(function (jtem, j) {
        if (jtem.dataset.sizeType == "ready-to-wear") {
          rtw.push(jtem);
          document.querySelector("#rtw-options").appendChild(jtem);
        } else {
          shoes.push(jtem);
          document.querySelector("#shoes-options").appendChild(jtem);
        }
      });
    } else {
      filterCons[i].innerHTML = item.innerHTML;
    }
  });

  filterCons.forEach(function (item, i) {
    let options = item.querySelectorAll(".checkbox");
    options.forEach(function (jtem, j) {
      jtem.addEventListener("click", function () {
        //console.log(jtem);
        filterSelector(jtem.id);
      });
    });
  });

  filterConsExtendo.forEach(function (item, i) {
    let options = item.querySelectorAll(".checkbox");
    options.forEach(function (jtem, j) {
      jtem.addEventListener("click", function () {
        //console.log(jtem);
        filterSelector(jtem.id);
      });
    });
  });

  filterOriginals.forEach(function (item, i) {
    let inputs = item.querySelectorAll("input");
    inputs.forEach(function (jtem, j) {
      if (jtem.checked) {
        //console.log(jtem.value);
        console.log(jtem);
        filterBar.classList.add("open");
        filterBtns[i].classList.add("active");
        filterParent[i].classList.add("show");
      }
    });
  });

  if (filterCons[0].querySelectorAll(".checkbox").length < 1) {
    console.log(filterCons[0].querySelectorAll(".checkbox").length + " ready to wear");
    document.querySelector("#rtw-heading").style.display = "none";
  }

  if (filterConsExtendo[0].querySelectorAll(".checkbox").length < 1) {
    console.log(filterConsExtendo[0].querySelectorAll(".checkbox").length + " shoes");
    document.querySelector("#shoes-heading").style.display = "none";
  }

  let filterSelector = function (selected_option) {
    let selection = realFilters.querySelectorAll(".checkbox");
    selection.forEach(function (item, i) {
      if (item.id == selected_option) {
        //console.log(item.id);
        //console.log("+");
        //console.log(selected_option);
        if (item.checked) {
          item.checked = false;
          //console.log(item.parentNode.parentNode.parentNode.parentNode);
          item.parentNode.parentNode.parentNode.parentNode.querySelector(".apply-btn").click();
          //filterOriginals[parent].querySelector(".apply-btn").click();
        } else {
          item.checked = true;
          //console.log(item.parentNode.parentNode.parentNode.parentNode);
          item.parentNode.parentNode.parentNode.parentNode.querySelector(".apply-btn").click();
          //filterOriginals[parent].querySelector(".apply-btn").click();
        }
      }
    });
    // if(selection.checked){
    //   selection.checked = false;
    //   filterOriginals[parent].querySelector(".apply-btn").click();
    // } else {
    //   selection.checked = true;
    //   filterOriginals[parent].querySelector(".apply-btn").click();
    // }
  };

  let checkFilters = function () {
    let filterForm = document.querySelector(".filter-form");
    let filterGroups = filterForm.querySelectorAll("summary");
    let clearFiltersBtn = filterForm.querySelector(".active-filters__clear");

    filterGroups.forEach(function (item, i) {
      let spans = item.querySelectorAll("span");
      spans.forEach(function (jtem, j) {
        if (jtem.classList.contains("filter-selected")) {
          clearFiltersBtn.classList.remove("hide");
        }
      });
    });
  };

  //Manual Mobile Buttons
  let sizeFilterBtn = document.querySelector(".mobile-size-btn");
  let colorFilterBtn = document.querySelector("#color-filter-btn");
  //let occasionFilterBtn = document.querySelector("#occasion-filter-btn");
  let materialFilterBtn = document.querySelector("#material-filter-btn");
  let availabilityFilterBtn = document.querySelector("#availability-filter-btn");
  let myMobileFilterBtns = [sizeFilterBtn, colorFilterBtn, materialFilterBtn, availabilityFilterBtn];

  myMobileFilterBtns.forEach(function (item, i) {
    item.addEventListener("click", function (event) {
      event.preventDefault();

      if (i == 0) {
        filterCons[0].classList.toggle("show");
        filterConsExtendo[0].classList.toggle("show");
      }
      if (i == 1) {
        filterCons[1].classList.toggle("show");
      }
      if (i == 2) {
        filterCons[2].classList.toggle("show");
      }
      if (i == 3) {
        filterCons[3].classList.toggle("show");
      }
      // if (i == 4) {
      //   filterCons[4].classList.toggle("show");
      // }
    });
  });

  //checkFilters();
}



//Views
let toggleView = document.querySelector(".toggle-view");
let collectionCon = document.querySelector("#collection-con"); // Updated selector

if (toggleView && collectionCon) {
  let viewBtn = toggleView.querySelector(".view-btn");
  let toggleBtns = toggleView.querySelectorAll(".toggle-btn");

  function updateCollectionView(activeBtn) {
    // Remove all existing view classes
    collectionCon.classList.remove("two-view", "four-view", "six-view");

    // Apply the correct class based on the active button
    if (activeBtn.classList.contains("two-view")) {
      collectionCon.classList.add("two-view");
    } else if (activeBtn.classList.contains("four-view")) {
      // If four-view is active, reset to default (no extra class)
    } else if (activeBtn.classList.contains("six-view")) {
      collectionCon.classList.add("six-view");
    }
  }

  // Cycle through views when clicking viewBtn
  viewBtn.addEventListener("click", function (e) {
    e.preventDefault(); // Prevent default link behavior

    let activeIndex = 0; // Start with 0, knowing there is always an active button

    // Find the index of the currently active toggle button
    for (let i = 0; i < toggleBtns.length; i++) {
      if (toggleBtns[i].classList.contains("active")) {
        activeIndex = i;
        break; // Stop looping once found
      }
    }

    // Remove active class from the current button
    toggleBtns[activeIndex].classList.remove("active");

    // Determine the next index, cycling back to 0 if at the last button
    let nextIndex = (activeIndex + 1) % toggleBtns.length; // Ensure cycling behavior

    // Add active class to the next button
    let nextBtn = toggleBtns[nextIndex];
    nextBtn.classList.add("active");

    // Update #collection-con class
    updateCollectionView(nextBtn);
  });

  // Add click event listeners to individual toggle buttons
  toggleBtns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent default link behavior

      // Remove active class from all buttons
      toggleBtns.forEach((b) => b.classList.remove("active"));

      // Add active class to the clicked button
      btn.classList.add("active");

      // Update #collection-con class
      updateCollectionView(btn);
    });
  });
}